import isSameDay from 'date-fns/isSameDay';
import { create } from 'zustand';
import { isIsoDate } from '../utils/date-time';
export const useBannerStore = create()((set, state) => ({
    bannerState: 'hidden',
    openBanner: () => set({ bannerState: 'open' }),
    closeBanner: () => set({ bannerState: 'closed' }),
    formState: '',
    setFormState: (formState) => set({ formState }),
    lastAnswered: '',
    setLastAnswered: () => set({ lastAnswered: new Date().toISOString() }),
    wasLastAnsweredToday: () => {
        const la = state().lastAnswered;
        if (la === '' || !isIsoDate(la))
            return false;
        return isSameDay(new Date(), new Date(la));
    },
}));
